import React from "react";
import validator from "validator";

export const required = (value, props) => {
	if (!value.toString().trim().length) {
		return <div className="invalid-feedback d-block">{`${props.placeholder} is Required.`}</div>;
	}
};

export const email = (value) => {
	if (!validator.isEmail(value)) {
		return <div className="invalid-feedback d-block">{`${value} is not a valid email.`}</div>;
	}
};

export const lt = (value, props) => {
	if (value.toString().trim().length > props.maxLength) {
		return <span className="invalid-feedback d-block">The value exceeded {props.maxLength} symbols.</span>;
	}
};

export const gt = (value, props) => {
	if (value.toString().trim().length < parseInt(props.minLength)) {
		return <span className="invalid-feedback d-block">The value must be at least {props.minLength} symbols..</span>;
	}
};

export const passwordEqual = (value, props, components) => {
	if (value !== components["password"][0].value) { // components['password'][0].value !== components['confirm'][0].value
		return <span className="invalid-feedback d-block">Passwords are not equal.</span>;
	}
};

export const passwordStrong = (value) => {
	if (!(/^(?=(?:[^A-Z]*[A-Z]){2})(?=(?:[^0-9]*[0-9]){2}).{8,}$/).test(value)) { // components['password'][0].value !== components['confirm'][0].value
		return <span className="invalid-feedback d-block">Password is not strong.</span>;
	}
};
